import type DisposalType from 'owa-service/lib/contract/DisposalType';
import doesFolderIdEqualName from 'owa-session-store/lib/utils/doesFolderIdEqualName';
import { getStore as getMailStore } from 'owa-mail-store/lib/store/Store';

/**
 * Return the default disposal type when deleting an item from the reading pane
 */
export default function getDefaultDisposalType(itemId: string): DisposalType {
    const item = getMailStore().items.get(itemId);
    const parentFolderId = item?.ParentFolderId?.Id;
    return doesFolderIdEqualName(parentFolderId, 'deleteditems') ||
        doesFolderIdEqualName(parentFolderId, 'junkemail')
        ? 'SoftDelete'
        : 'MoveToDeletedItems';
}
